import _ from 'lodash';
import { HttpClient, type ControllerFlowAPI } from '@wix/yoshi-flow-editor';

type ErrorMonitorOptions = Parameters<
  ControllerFlowAPI['errorMonitor']['captureException']
>[1];

type Options = {
  transaction?: string;
} & ErrorMonitorOptions;

export function monitor(api: ControllerFlowAPI) {
  const { panoramaClient } = api;
  const { wixCodeApi, platformAPIs } = api.controllerConfig;

  const msid = platformAPIs?.bi?.metaSiteId;
  const user = {
    id: wixCodeApi.user.currentUser.id,
    role: wixCodeApi.user.currentUser.role,
    loggedIn: wixCodeApi.user.currentUser.loggedIn,
  };

  return {
    captureException(exception: Error, options?: Options) {
      panoramaClient.errorMonitor().reportError(
        exception,
        _.merge(options, {
          user,
          tags: {
            msid,
            url: getCurrentUrl(),
            status: HttpClient.isHttpError(exception)
              ? exception.response?.status
              : undefined,
          },
        }),
      );
    },
  };

  function getCurrentUrl() {
    const { baseUrl, path } = wixCodeApi.location;
    const url = new URL(path.join('/'), baseUrl);

    return url.toString();
  }
}
